<template>
  <div id="app">
    <Header />
    <keep-alive include="Donation,DonationDetail">
        <router-view :key="$route.fullPath" />
    </keep-alive>

    <basket-modal></basket-modal>
    <login-modal :show="modal.isLoginModal" />
    <payment-modal></payment-modal>
    <redirect-modal></redirect-modal>
    <app-footer></app-footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Header from '@/components/Header'
import BasketModal from '@/components/BasketModal'
import LoginModal from '@/components/LoginModal'
import PaymentModal from '@/components/PaymentModal'
import RedirectModal from '@/components/RedirectModal'
import AppFooter from '@/components/AppFooter'

export default {
  computed: {
    ...mapState(['modal'])
  },
  components: {
    Header,
    BasketModal,
    LoginModal,
    PaymentModal,
    RedirectModal,
    AppFooter
  },
  methods: {
    base64decode(s) {
      const e = {}; let i; let b = 0; let c; let x
      let l = 0; let a; let r = ''; const w = String.fromCharCode; const L = s.length
      const A = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
      for (i = 0; i < 64; i += 1) { e[A.charAt(i)] = i }
      for (x = 0; x < L; x += 1) {
        // eslint-disable-next-line no-bitwise
        c = e[s.charAt(x)]; b = (b << 6) + c; l += 6
        // eslint-disable-next-line no-unused-expressions, no-bitwise
        while (l >= 8) { ((a = (b >>> (l -= 8)) & 0xff) || (x < (L - 2))) && (r += w(a)) }
      }
      return r
    }
  },
  watch: {
    $route() {
      if (this.user.loggedIn) {
        const { token } = this.user.data
        const payload = JSON.parse(this.base64decode(token.split('.')[1]))

        if (payload.exp < Math.round((new Date()).getTime() / 1000)) {
          this.$store.commit('logout')
        } else if (payload.exp < Math.round((new Date()).getTime() / 1000) + 259200) {
          this.$http.post('v2/user/refresh').then((res) => {
            this.$store.commit('loggedIn', res.data)
          }).catch(() => {
            this.$store.commit('logout')
          })
        }
      }
    }
  }
}
</script>
